import { useSelector } from "react-redux";

import { usePreviewModeContext } from "@contexts/preview-mode-context";
import { isBetween } from "@stadium/helpers/dayjs";
import { getUniversalHolidayNote } from "@selectors/config";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getCountry } from "@selectors/country";

import { NON_INTERNATIONAL_COUNTRIES_ISO } from "@stadium/constants";

import styles from "./main.module.scss";

const VendorHolidayMessage = ({ vendor }) => {
  const { previewMode } = usePreviewModeContext();
  const universalHolidayNote = useConfig(getUniversalHolidayNote);
  const selectedCountry = useSelector(getCountry);

  if (!vendor && !universalHolidayNote) return null;

  const { holidayNote, holidayEndDate, holidayStartDate } = vendor || {};
  if (
    !previewMode &&
    holidayStartDate &&
    holidayEndDate &&
    holidayNote &&
    isBetween(new Date(), holidayStartDate, holidayEndDate)
  ) {
    return <span className={`${styles.holidayNoteText} t-bg-3`}>{holidayNote}</span>;
  }
  if (universalHolidayNote && !NON_INTERNATIONAL_COUNTRIES_ISO.includes(selectedCountry?.iso)) {
    return <span className={`${styles.holidayNoteText} t-bg-3`}>{universalHolidayNote}</span>;
  }
  return null;
};

export default VendorHolidayMessage;
